import { ILoadingPayload } from "../../model";
import { eUtilActionTypes } from "./types";

export const setLoading = (payload: ILoadingPayload) => ({
  type: eUtilActionTypes.SET_LOADING,
  payload
});
